import QuoteMatchingDistributionSection from '../../../sections/AdminDashboard/Configuration/QuoteMatchingDistribution';

const QuoteMatchingDistribution = () => <QuoteMatchingDistributionSection />;

export default QuoteMatchingDistribution;
